import React, { useCallback, useEffect } from "react";
import {
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExportContainer,
  useGridApiContext,
  GridCsvExportMenuItem,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid-pro";
import { toast } from "react-toastify";
import DropDownButton from "../../ReusableComponent/Header/DropDownButton";
import RightSideButton from "../../ReusableComponent/Header/RightSideButton";
import LeftSideButton from "../../ReusableComponent/Header/LeftSideButton";
import MenuItem from "@mui/material/MenuItem";
import ExportButton from "./ExportButton";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import equipmentGroupStore from "../../../Stores/EquipmentGroupStore";
import equipmentGroupConstants from "../../../Constants/EquipmentGroupConstants";
import { PageHeader } from "../../MuiOverRideComponent/PageHeader";
import BulkExportInspectionReport from "../EquipmentBulkOperation/BulkExportInspectionReport";
var dateFormat = require("dateformat");
export default function GridHeaderBar({
  handleDropChange,
  handleGridSettingChange,
  selectedEqList,
  handleMultipleActive,
  gridAction,
  rowCount,
  state,
  setState,
  reportCode,
  hasRow,
  handleExport,
  handleBulkOperationSuccess,
  handleOpenEquipmentGrpConf,
  handleBulkExportInspectionReport,
}) {
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const handleEcxcel = useCallback((exportData) => {
    if (exportData !== null && exportData !== undefined) {
      const url = window.URL.createObjectURL(exportData);
      let a = document.createElement("a");
      let name =
        "Export_" + dateFormat(Date(), "yyyy-mm-dd_hh-mm-ss") + ".xlsx";

      a.hidden = "";
      a.href = url;
      a.download = name;
      a.click();
      setGlobalSpinner(false);
    }

    return () => {};
  }, []);

  useEffect(() => {
    function updatData() {
      var tmp = equipmentGroupStore.getExport();
      handleEcxcel(tmp);
      // setNavItem(equipmentGroupStore.getNavbarItem());
    }
    equipmentGroupStore.addChangeListener(
      equipmentGroupConstants.EXPORT_SUCCESS,
      updatData
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        equipmentGroupConstants.EXPORT_SUCCESS,
        updatData
      );
    };
  }, []);
  useEffect(() => {
    function updatData() {
      var tmp = equipmentGroupStore.getExport();
      toast.error(tmp);
      setGlobalSpinner(false);
    }
    equipmentGroupStore.addChangeListener(
      equipmentGroupConstants.EXPORT_FAILURE,
      updatData
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        equipmentGroupConstants.EXPORT_FAILURE,
        updatData
      );
    };
  }, []);
  return (
    <>
      {reportCode !== "ScrapEquipment" && (
        <div>
          {/* Title on the Left */}
          <div className="row w-100 ml-0 mr-0">
            <div className="col-4">
              <PageHeader
                Title={
                  sessionStorage.getItem("eqBez") !== null &&
                  sessionStorage.getItem("eqBez") !== undefined
                    ? sessionStorage.getItem("plant") +
                      "/" +
                      sessionStorage.getItem("eqBez").toUpperCase()
                    : null
                }
              />
            </div>{" "}
            {/* <div className="col d-flex justify-content-end">
            <GridToolbarQuickFilter
              style={{ marginLeft: "auto", width: "70%" }}
            />
          </div> */}
          </div>

          {/* Quick Filter on the Right */}
        </div>
      )}

      <GridToolbarContainer id="mainGridButton">
        <div>
          <GridToolbarColumnsButton
            disabled={!hasRow}
            componentsprops={{
              tooltip: {
                componentsprops: {
                  root: {
                    component: "span",
                  },
                },
              },
            }}
          />

          <GridToolbarFilterButton
            //    disabled={rows.length === 0}
            componentsprops={{
              tooltip: {
                componentsprops: {
                  root: {
                    component: "span",
                  },
                },
              },
            }}
          />

          <GridToolbarDensitySelector
            disabled={!hasRow}
            componentsprops={{
              tooltip: {
                componentsprops: {
                  root: {
                    component: "span",
                  },
                },
              },
            }}
          />
          <CustomExportButton
            handleExport={handleExport}
            reportCode={reportCode}
            state={state}
          />
          {/* <GridToolbarExport
          disabled={!hasRow}
          componentsprops={{
            tooltip: {
              componentsprops: {
                root: {
                  component: "span",
                },
              },
            },
          }}
        /> */}

          {reportCode !== "ScrapEquipment" && (
            <DropDownButton
              handleDropChange={handleDropChange}
              reportCode={reportCode}
              state={state}
              setState={setState}
            />
          )}
          {reportCode === "OrdersOView" && (
            <BulkExportInspectionReport
              handleBulkExportInspectionReport={
                handleBulkExportInspectionReport
              }
            />
          )}
        </div>
        {gridAction && (
          <div style={{ marginLeft: "auto" }} className="d-flex">
            <RightSideButton
              gridAction={gridAction}
              rowCount={rowCount}
              reportCode={reportCode}
              selectedEqList={selectedEqList}
              handleMultipleActive={handleMultipleActive}
              handleGridSettingChange={handleGridSettingChange}
              handleBulkOperationSuccess={handleBulkOperationSuccess}
              handleOpenEquipmentGrpConf={handleOpenEquipmentGrpConf}
            />
          </div>
        )}
      </GridToolbarContainer>
    </>
  );
}

function CustomExportButton(props) {
  return (
    <GridToolbarExportContainer>
      <GridCsvExportMenuItem />
      {props.reportCode !== "ScrapEquipment" && (
        <ExportButton
          handleExport={props.handleExport}
          reportCode={props.reportCode}
          state={props.state}
        />
      )}
    </GridToolbarExportContainer>
  );
}
function JsonExportMenuItem(props) {
  const apiRef = useGridApiContext();

  const { hideMenu } = props;

  return (
    <MenuItem
      onClick={() => {
        // const jsonString = getJson(apiRef);
        // const blob = new Blob([jsonString], {
        //   type: "text/json",
        // });
        // exportBlob(blob, "DataGrid_demo.json");
        // Hide the export menu after the export
        // hideMenu?.();
      }}
    >
      Export JSON
    </MenuItem>
  );
}
